export const OpenStateActions = {
  open: 'SET_STATE_OPEN',
  close: 'SET_STATE_CLOSE',
  toggle: 'SET_STATE_TOGGLE',
  closeall: 'SET_STATE_CLOSE_ALL',
} as const;
